import NorthIcon from "@mui/icons-material/North";
import SouthIcon from "@mui/icons-material/South";

const changeDirection = (direction) => {
  return direction === "asc" ? "desc" : "asc";
};

const sortIcon = (property, selectedProperty, selectedDirection) => {
  if (selectedProperty === property) {
    return selectedDirection === "asc" ? <NorthIcon /> : <SouthIcon />;
  }
  return "";
};

const sortingUtils = { changeDirection, sortIcon };

export default sortingUtils;